import { render } from "./CourseManagement.vue?vue&type=template&id=1b41626d&scoped=true"
import script from "./CourseManagement.vue?vue&type=script&lang=js"
export * from "./CourseManagement.vue?vue&type=script&lang=js"

import "./CourseManagement.vue?vue&type=style&index=0&id=1b41626d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b41626d"]])

export default __exports__